import { Command } from '../command.js';
import { Mesh, Object3D, ObjectLoader } from 'three';
import { Editor } from '../editor.js';

/**
 * @param editor Editor
 * @param object THREE.Object3D
 * @constructor
 */
class AddObjectCommand extends Command {
	object:Object3D;
	constructor( editor:Editor, object:Object3D ) {

		super( editor );

		this.type = 'AddObjectCommand';

		this.object = object;
		
		if ( object !== undefined ) {

			this.name = `Add Object: ${object.name}`;

		}

	}

	execute() {

		this.editor.addObject( this.object );
		this.editor.select( this.object );

	}

	undo() {

		this.editor.removeObject( this.object );
		this.editor.deselect();

	}

}

export { AddObjectCommand };
